import React from "react";

function Profile_header(){

    return(
        <div className="profile-header">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h1>پروفایل</h1>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default Profile_header;